/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useEffect, useState, useCallback, useContext } from 'react';
import { MyContext } from '../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';

const Razorpay = ({ Amount, attributes }) => {

    const { setPaymentRes, setPaymentLoading } = useContext(MyContext);

    const [userData, setUserData] = useState();

    const openPayModal = useCallback(() => {

        setPaymentLoading(false);

        const options = {
            key: attributes,
            amount: Amount * 100,
            name: "Astrotolk",
            description: "some description",
            image: "https://cdn.razorpay.com/logos/7K3b6d18wHwKzL_medium.png",
            handler: (response) => {
                setPaymentRes("PaymentDone");
                sessionStorage.setItem("transactionid", response.razorpay_payment_id);
            },
            modal: {
                ondismiss: () => {
                    setPaymentRes("PaymentFaild");
                }
            },
            prefill: {
                name: userData && userData?.name,
                contact: userData && userData?.phone,
                email: userData && userData?.email,
            },
            notes: {
                address: "some address",
            },
            theme: {
                color: "#F37254",
                hide_topbar: false,
            },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();

    }, [Amount, userData]);

    useEffect(() => {
        const localData = secureLocalStorage.getItem("Logindata");
        if (!Amount || !localData || localData === "null" || localData === "undefined") return;
        try {
            const parsedData = typeof localData === 'string' ? JSON.parse(localData) : localData;
            if (parsedData) {
                setUserData(parsedData);
            }
        } catch (e) {
            console.error("Error parsing Logindata in Razorpay:", e);
        }
    }, [Amount]);

    useEffect(() => {
        if (userData && Amount) {
            openPayModal();
        }
    }, [Amount, userData]);

    return null;
};

export default Razorpay;
/* jshint ignore:end */